import {useSortable} from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";

const SortableItemRow = ({ item, ...props }: any) => {
    const {
        attributes,
        listeners,
        setNodeRef,
        transform,
        transition
    } = useSortable({ id: item.item.id });
    
    const style: React.CSSProperties = {
        transform: CSS.Transform.toString(transform),
        transition,
        display:'flex',
        background:'#fff'
    };

    return (
        <div ref={setNodeRef} style={style} className="alert alert-success">

            <span {...attributes} {...listeners} style={{cursor:'grab', marginRight:10,float:'left', fontSize:36}}>
                <i className="mdi mdi-drag"></i>
            </span>

            <div style={{ flex: 1, display: 'flex', alignItems: 'center' }}>
                {
                    item.item.fileMimeType === 6 ? (
                        <span style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                            <i
                                className="mdi mdi-arrow-down-drop-circle"
                                style={{ color: '#97f80c', fontSize: 20 }}
                            />
                            {item.item.title}
                        </span>
                    ) : (
                        <span>
                            {item.item.title}
                        </span>
                    )
                }
            </div>
            {
                item.item.fileMimeType !== 6 &&
                <div style={{cursor:'pointer'}} onClick={() => props.openForType(item.item.fileMimeType, item.item.urlFile, item.item.subUrl)}>
                    <span style={{display:'block'}}>
                        <i className="mdi mdi-open-in-new"></i> Abrir
                    </span>
                    <span style={{display:'block', fontSize:9}}>
                        {props.getNameTypeFile(item.item.fileMimeType)}
                    </span>
                </div>
            }
            
            <div style={{cursor:'pointer'}} onClick={()=>{props.openModalEditItem(item.item, props.subCatId)}}>
                <span>
                    <i className="mdi mdi-pencil-box" style={{marginLeft:10,paddingLeft:10, borderLeft:'1px solid #ccc'}}></i> Editar
                </span>
            </div>
            <div style={{cursor:'pointer'}} onClick={() => props.toggleActiveItem(item.item)}>
                <span style={{cursor: 'pointer',display:'block' }}>
                    <i
                        className={`mdi ${item.item.active ? "mdi-toggle-switch" : "mdi-toggle-switch-off"}`}
                        style={{
                            fontSize: 26,
                            color: item.item.active ? "#28a745" : "#999",
                            marginLeft:10,paddingLeft:10, borderLeft:'1px solid #ccc'
                        }}
                    />
                </span>
            </div>
            <div style={{cursor:'pointer'}} onClick={() => props.deleteItem(item.item.id)}>
                <span>
                <i className="mdi mdi-delete-circle" style={{fontSize:25, marginLeft:10,paddingLeft:10, borderLeft:'1px solid #ccc', color:'#c52828'}}></i>
                </span>
            </div>

        </div>
    );
};
export default SortableItemRow;